export const formTextFieldStyles = {
	root: (canAddNewItem?: boolean) => ({
		width: '100%',
		display: 'grid',
		gridTemplateColumns: {
			xs: '1fr',
			sm: 'min-content 1fr'
		},
		alignItems: canAddNewItem ? 'flex-start' : 'center',
		gap: 1
	}),

	label: {
		pt: 1,
		height: '100%',
		minWidth: 200,
		typography: 'subtitle1',
		color: 'text.primary',
		userSelect: 'none',
		fontWeight: '700',
		pointerEvents: 'none'
	},

	fieldWrap: {
		gridTemplateColumns: {
			xs: '1fr min-content'
		},
		display: 'grid',
		position: 'relative',
		width: '100%'
	},

	field: {
		position: 'relative'
	},

	textField: (indicateError: boolean, isDirty: boolean) => ({
		backgroundColor: 'background.paper',
		width: '100%',

		'& .MuiInputBase-root': {
			height: '48px !important'
		},

		// Input text color
		'& .MuiOutlinedInput-input': {
			color: indicateError
				? 'var(--mui-palette-error-main)'
				: isDirty
					? 'var(--mui-palette-success-light)'
					: 'var(--mui-palette-text-primary)',
			WebkitTextFillColor: indicateError
				? 'var(--mui-palette-error-main)'
				: isDirty
					? 'var(--mui-palette-success-light)'
					: 'var(--mui-palette-text-primary)',
			pr: 12
		},

		// Border color
		'& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {
			borderColor: indicateError
				? 'var(--mui-palette-error-main)'
				: isDirty
					? 'var(--mui-palette-success-light)'
					: 'var(--mui-palette-divider)',
			borderWidth: 1
		},

		'& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
			borderColor: indicateError
				? 'var(--mui-palette-error-main)'
				: isDirty
					? 'var(--mui-palette-success-light)'
					: 'var(--mui-palette-action-hover)',
			borderWidth: 1
		},

		// Focus still primary blue (never overridden)
		'& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
			borderColor: 'primary.main',
			borderWidth: 1
		},

		'& .MuiOutlinedInput-root': {
			height: '100%'
		},

		'& .MuiFormHelperText-root': {
			margin: 0
		}
	}),

	dateField: {
		'& .MuiInputBase-input': {
			display: 'flex',
			flexDirection: 'row-reverse',
			alignItems: 'center',
			justifyContent: 'flex-end'
		},
		'& ::-webkit-calendar-picker-indicator': {
			cursor: 'pointer',
			marginRight: '8px',
			marginLeft: '-4px'
		}
	},

	badgeWrap: {
		position: 'absolute',
		right: '12px',
		top: '50%',
		transform: 'translateY(-50%)',
		display: 'flex',
		alignItems: 'center',
		gap: 0.5,
		pointerEvents: 'none'
	},

	requiredChip: {
		bgcolor: 'grey.100',
		color: 'text.secondary',
		borderRadius: '16px',
		height: 24,
		fontSize: 12
	},

	removeButton: {
		marginLeft: 1,
		// don't stretch to match the field's height (which grows with the error message)
		alignSelf: 'start',
		marginTop: 1.5
	},

	addNewItemButtonWrap: {
		display: 'flex',
		justifyContent: 'flex-start',
		alignItems: 'center',
		width: 'fit-content',
		marginTop: 1
	}
};
